
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'الرئيسية', path: '/' },
    { name: 'من نحن', path: '/about' },
    { name: 'المنتجات', path: '/products' },
    { name: 'العلامات التجارية', path: '/brands' },
    { name: 'تواصل معنا', path: '/contact' },
  ];

  return (
    <nav className={`fixed top-0 right-0 left-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'shadow-lg' : 'shadow-sm border-b border-silver-light'}`}>
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-24">
          {/* Logo - مكبّر */}
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/3054ead814191935f25c9e6dd446a98c.png"
              alt="شركة الحلول الأمنية المتكاملة"
              className="h-20 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-[15px] font-medium transition-all duration-300 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary'
                    : 'text-navy-light hover:text-primary'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center gap-4">
            <Link
              to="/contact"
              className="px-6 py-3 bg-primary text-white text-[15px] font-semibold rounded-lg hover:bg-primary-dark transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              اطلب عرض سعر
            </Link>
            <a
              href="https://wa.me/966500000000"
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 flex items-center justify-center bg-[#25D366] text-white rounded-full hover:scale-110 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-navy"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-silver-light py-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-3 text-[15px] font-medium transition-all duration-300 ${
                  location.pathname === link.path
                    ? 'text-primary bg-primary/5'
                    : 'text-navy-light hover:text-primary hover:bg-primary/5'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="px-4 pt-4 flex flex-col gap-3">
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-6 py-3 bg-primary text-white text-[15px] font-semibold rounded-lg hover:bg-primary-dark transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
              >
                اطلب عرض سعر
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
